module.exports = __webpack_public_path__ + "static/sol-healthcare-section-2-img-54a2d2ce2ffd16facafb95ac569412cc.png";